import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
// import backImage from "../../assets/images/back-icon.svg"
import Button from "../../components/Button"
import moment from "moment"
import { getApprovalPendingRasieRequests } from "core/services/api/mrdService"
import "./PendingRaiseRequests.scss"

function PendingRaiseRequests() {
  const history = useHistory()

  const [pendingApprovalRaiseRequests, setPendingApprovalRaiseRequests] = useState<any>([])
  const [sortByTime, updateSortBy] = useState("asc");

  useEffect(() => {
    //Pending Raise Requests for Approval API
    getApprovalPendingRasieRequests()
      .then((res: any) => {
        const temp = [...res]
        temp?.sort((a: any, b: any) => {
          return sortByTime === "asc" ?
            a?.formData?.applicantDate > b?.formData?.applicantDate ? 1 : -1
            : a?.formData?.applicantDate < b?.formData?.applicantDate ? 1 : -1
        })
        setPendingApprovalRaiseRequests(temp)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    if (sortByTime) {
      const temp = [...pendingApprovalRaiseRequests]
      temp?.sort((a: any, b: any) => {
        return sortByTime === "asc" ?
          a?.formData?.applicantDate > b?.formData?.applicantDate ? 1 : -1
          : a?.formData?.applicantDate < b?.formData?.applicantDate ? 1 : -1
      })
      setPendingApprovalRaiseRequests(temp)
    }
  }, [sortByTime])

  const handleEdit = async (id: any, patientId: any, recordId: any) => {
    console.log("edit", id)
    // history.push(`/addNewReferrals`, path)
    history.push({
      pathname: "/mrdApprovalRequest",
      state: {
        selected: recordId
      },
    })
  }

  const handleSortOption = (e: any) => {
    updateSortBy(sortByTime === "asc" ? "desc" : "asc")
  }

  const handleSearch = (e: any) => {
    if (e?.length) {
      const copy = [...pendingApprovalRaiseRequests]
      const temp = copy?.filter((each: any) => {
        return (
          each?.formData?.raiseRequestPatientId?.toLowerCase()?.includes(e?.toLowerCase()) ||
          each?.formData?.raiseRequestPatientName?.toLowerCase()?.includes(e?.toLowerCase())
        )
      })
      temp?.sort((a: any, b: any) => {
        return sortByTime === "asc" ?
          a?.formData?.applicantDate > b?.formData?.applicantDate ? 1 : -1
          : a?.formData?.applicantDate < b?.formData?.applicantDate ? 1 : -1
      })
      setPendingApprovalRaiseRequests(temp)
    } else {
      getApprovalPendingRasieRequests()
        .then((res: any) => {
          const temp = [...res]
          temp?.sort((a: any, b: any) => {
            return sortByTime === "asc" ?
              a?.formData?.applicantDate > b?.formData?.applicantDate ? 1 : -1
              : a?.formData?.applicantDate < b?.formData?.applicantDate ? 1 : -1
          })
          setPendingApprovalRaiseRequests(temp)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  return (
    <div className="approval-request-wrapper">
      <div className="approval-request-section">
        {/* <div className="approval-heading-container">
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/")
            }}
          >
            <img
              src="../../assets/images/back-icon.svg"
              height={"60px"}
              width={"60px"}
              alt="back button"
              className="back_button"

            />
          </div>
          <div className="approval-request-text">MRD</div>
        </div> */}
        <section className="section-two-container">
          <div className="search-dropdown-wrapper">
            <div className="row pl-42 pt-17px">
              <div className="col-md-6 col-lg-6">
                <span>
                  <input
                    className="inputGlobalSearch"
                    placeholder="Search"
                    onChange={(e) => {
                      handleSearch(e.target.value)
                    }}
                  />
                  <img
                    src="assets/images/searchIcon.svg"
                    alt=""
                    style={{
                      marginLeft: "-50px",
                      width: "26px",
                      height: "26px",
                    }}
                  />
                </span>
              </div>
              <div className="col-md-1 col-lg-1">
                {/* <Dropdown
                  placeholder="Sort"
                  options={rmoIdOptions}
                  selected=""
                ></Dropdown> */}
                <Button
                  text="Sort By Time"
                  outline={true}
                  onClick={handleSortOption}
                  id="sort-by-time"
                />
              </div>
            </div>
          </div>
          {pendingApprovalRaiseRequests?.map((item: any) => {
            return (
              <div className="pending-appointment-request-wrapper">
                <div className="row patientid">
                  <div className="col-md-1 col-lg-1">
                    <label className="patient-id-container">Patient ID:</label>
                  </div>
                  <div className="col-md-2 col-lg-2 p-0 patientidvalue">
                    {item?.formData?.raiseRequestPatientId}
                  </div>
                  <div className="col-md-9 col-lg-9 editSection">
                    <div style={{ paddingLeft: "20px" }}>
                      <img
                        className="cursor-pointer"
                        src={"../../../assets/images/CRedit.svg"}
                        alt="edit"
                        width={24}
                        height={24}
                        onClick={() =>
                          handleEdit(
                            item?.id,
                            item?.patientId,
                            item
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row pt-28 patientdetails">
                  <div className="col-12 d-flex">
                    <div className="col-4 pl-47 sectionone">
                      <div className="row">
                        <div className="col-12 d-flex pt-24">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Patient name:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.formData?.raiseRequestPatientName}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Requested By:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.formData?.RequstedByName}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectiontwo">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Date:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {/* {item.approvalRaisedTime?.slice(0, 10)}
                               */}
                              {item?.formData?.dateOfApplication
                                ? moment(item?.formData?.dateOfApplication).format(
                                  "DD-MM-yyyy"
                                )
                                : ""}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectionthree">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Contact Number:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.formData?.RequstedByContactNumber}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Email:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.formData?.RequstedByEmail}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row complaintsection">
                  <div className="col-1">
                    <label className="patient-id-container">Request For:</label>
                  </div>
                  <div className="col-11 complaintreason">
                    <label className="values-container-field">
                      {item?.formData?.AccessTo[0]}
                    </label>
                  </div>
                </div>
                <div className="row statussection">
                  <div className="col-1">
                    <div className="row">
                      <label className="patient-id-container">Status:</label>
                      {/* <label className="patient-id-container">Reason:</label> */}
                    </div>
                  </div>
                  <div className="col-11 statusdetails">
                    <div className="row">
                      <label className="values-container-field">PENDING</label>
                      {/* <label className="values-container-field">{item.reason}</label> */}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </section>
      </div>
    </div>
  )
}

export default PendingRaiseRequests
